import { render, staticRenderFns } from "./CreateMessageForm.vue?vue&type=template&id=4d7be39f"
import script from "./CreateMessageForm.vue?vue&type=script&lang=js"
export * from "./CreateMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports